export const assets = [
  {
    id: '1',
    name: 'api.example.com',
    type: 'web',
    status: 'active',
    region: 'North America',
    updatedAt: '2h ago',
    tags: ['production', 'api'],
    vulnerabilities: {
      critical: 0,
      high: 2,
      medium: 3,
      low: 5
    },
    riskScore: 'B'
  },
  {
    id: '2',
    name: 'prod-db-01',
    type: 'database',
    status: 'vulnerable',
    region: 'Europe',
    updatedAt: '1h ago',
    tags: ['production', 'database'],
    vulnerabilities: {
      critical: 1,
      high: 3,
      medium: 2,
      low: 4
    },
    riskScore: 'D'
  },
  {
    id: '3',
    name: 'app-server-01',
    type: 'server',
    status: 'maintenance',
    region: 'Asia Pacific',
    updatedAt: '3h ago',
    tags: ['production', 'application'],
    vulnerabilities: {
      critical: 0,
      high: 1,
      medium: 4,
      low: 6
    },
    riskScore: 'C'
  }
];

export const metrics = {
  web: 156,
  servers: 89,
  databases: 34,
  network: 67,
  vulnerable: 12,
  secure: 334,
  total: 346
};